<template>
  <div v-if="$ability.can('write', 'CashFlow')">
    <div class="p-grid">
      <div class="p-col-12 p-md-5 p-lg-4">
        <AppSkeletonCardForm v-show="loading" :rows="10" />
        <Card v-show="!loading">
          <template v-slot:title>
            Dados do Lançamento
            <span
              v-if="$route.params.id"
              style="font-size: 1.1rem; font-weight: 500"
            >
              #{{ $route.params.id }}
            </span>
          </template>
          <template v-slot:content>
            <CashFlowForm ref="form"></CashFlowForm>
          </template>
          <template v-slot:footer>
            <div class="p-grid p-jc-between">
              <div style="padding-left: 8px">
                <Button
                  v-if="$route.params.id"
                  label="Excluir"
                  class="p-button-outlined p-button-danger"
                  icon="pi pi-trash"
                  :disabled="!$ability.can('delete', 'CashFlow')"
                  @click="openDeleteModal()"
                />
              </div>
              <div style="padding-right: 8px">
                <router-link tag="span" :to="{ name: 'cashflow.list' }">
                  <Button label="Cancelar" class="p-button-outlined p-mr-2" />
                </router-link>
                <AppButton
                  label="Salvar"
                  @click="save()"
                  :loading="loadingSave"
                />
              </div>
            </div>
          </template>
        </Card>
      </div>
      <div class="p-col-12 p-md-7 p-lg-8" v-if="!$route.params.id">
        <Card>
          <template v-slot:title>Últimos Lançamentos</template>
          <template v-slot:content>
            <CashFlowTable></CashFlowTable>
          </template>
        </Card>
      </div>
      <div class="p-col-12 p-md-7 p-lg-8" v-if="$route.params.id">
        <CashFlowRelated :transaction="formData"></CashFlowRelated>
      </div>
      <div class="p-col-12" v-if="$route.params.id">
        <div class="p-grid p-jc-end p-mt-2">
          <router-link tag="span" :to="{ name: 'cashflow.list' }">
            <Button label="Voltar" class="p-button-outlined p-mr-2" />
          </router-link>
        </div>
      </div>
    </div>
    <AppModalDelete
      type="Lançamento"
      :visible="deleteConfirmVisible"
      :item="`Lançamento do tipo ${
        formData.typeId === 1 ? 'Receita' : 'Despesa'
      } - Data ${$formatDate(formData.date)}`"
      @confirm="onDelete()"
      @cancel="deleteConfirmVisible = false"
    ></AppModalDelete>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import CashFlowForm from './components/CashFlowForm.vue';
import CashFlowTable from './components/CashFlowTable.vue';
import { CashFlowTransactionApi } from '../../services/api';
import CashFlowRelated from './components/CashFlowRelated.vue';

export default {
  name: 'CashFlowEdit',
  components: {
    CashFlowForm,
    CashFlowTable,
    CashFlowRelated,
  },
  data() {
    return {
      loading: false,
      loadingSave: false,
      deleteConfirmVisible: false,
      formData: {},
    };
  },
  computed: {
    ...mapFields('app', ['user']),
  },
  async mounted() {
    if (!this.$route.params.id) {
      const responsibleName = this.user.name || this.user.username;
      this.$refs.form.setData({ responsibleName });
      return;
    }

    try {
      this.loading = true;
      const data = await CashFlowTransactionApi.fetchById(
        this.$route.params.id
      );
      this.formData = data;
      this.$refs.form.setData(data);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async save() {
      try {
        const formData = await this.$refs.form.submit();
        if (!formData) {
          return;
        }
        this.loadingSave = true;
        if (!this.$route.params.id) {
          await CashFlowTransactionApi.create(formData);
        } else {
          await CashFlowTransactionApi.update(this.$route.params.id, formData);
        }
        this.$router.push({ name: 'cashflow.list' });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingSave = false;
      }
    },
    handleError(error) {
      console.log(error);
      let detail = 'Não foi possível salvar o lançamento.';
      this.$toast.add({
        severity: 'error',
        summary: 'Desculpe!',
        detail,
        life: 3000,
      });
    },
    openDeleteModal() {
      this.deleteConfirmVisible = true;
    },
    async onDelete() {
      try {
        await CashFlowTransactionApi.delete(this.$route.params.id);
        this.$router.push({ name: 'cashflow.list' });
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Desculpe!',
          detail: 'Não foi possível excluir o lançamento.',
          life: 3000,
        });
      } finally {
        this.deleteConfirmVisible = false;
      }
    },
  },
};
</script>

<style>
</style>